<!-- Card view -->
<div class="d-flex align-items-center header-wrapper" *ngIf="!viewDetails && !viewUserDetails && !viewProposalMappingDetails && !viewPrivilegeDetails && !viewUserwiseDetails && !viewRoleDetails">
  <span class="header">SYSTEM ADMINISTRATION</span>
  <span class="sub-heading">Manage users, projects, and system privileges.</span>
</div>
<div class="dashboard-grid" *ngIf="!viewDetails && !viewUserDetails && !viewProposalMappingDetails && !viewPrivilegeDetails && !viewUserwiseDetails && !viewRoleDetails">
  <div class="card-container" *ngFor="let card of cards">
    <div class="card-content">
      <div class="border-class-radius" [ngClass]="card.borderClass"></div>
      <div class="inner-content align-items-center d-flex ">
        <div class="rounded-circle bg-primary-subtle icon-bg">
          <i [ngClass]="card.iconClass"></i>
        </div>
        <h3>{{ card.title }}</h3>
        <p>{{ card.description }}</p>
        <button pButton type="button" label="View Details" class="view-btn" (click)="viewDetailsClicked(card)"></button>
      </div>
    </div>
  </div>
</div>

<!-- Role-wise Access privilege -->
<div class="access-privileges-container p-4" *ngIf="viewDetails">
  <app-access-privilege></app-access-privilege>
  <div class=" switch-module-btn" >
    <div class="toggle-view d-flex" (click)="switchModule = true"><i class="pi pi-th-large" pTooltip="Switch Mode" tooltipPosition="bottom"></i></div>
  </div>
</div>

<!-- User-wise Access privilege -->
<div class="access-privileges-container p-4" *ngIf="viewUserwiseDetails">
  <app-user-access-privilege></app-user-access-privilege>
  <div class=" switch-module-btn" >
    <div class="toggle-view d-flex" (click)="switchModule = true"><i class="pi pi-th-large" pTooltip="Switch Mode" tooltipPosition="bottom"></i></div>
  </div>
</div>

<!-- Proposal mapping -->
<div *ngIf="viewProposalMappingDetails">
  <app-user-mapping></app-user-mapping>
  <div class=" switch-module-btn" >
    <div class="toggle-view d-flex" (click)="switchModule = true"><i class="pi pi-th-large" pTooltip="Switch Mode" tooltipPosition="bottom"></i></div>
  </div>
</div>

<!-- Privilege details -->
<div class="" *ngIf="viewPrivilegeDetails">
  <app-privilege></app-privilege>
  <div class=" switch-module-btn" >
    <div class="toggle-view d-flex" (click)="switchModule = true"><i class="pi pi-th-large" pTooltip="Switch Mode" tooltipPosition="bottom"></i></div>
  </div>
</div>

<!-- Users -->
<div class="padding-right" *ngIf="viewUserDetails">
  <app-user-details></app-user-details>
  <div class=" switch-module-btn" >
    <div class="toggle-view d-flex" (click)="switchModule = true"><i class="pi pi-th-large" pTooltip="Switch Mode" tooltipPosition="bottom"></i></div>
  </div>
</div>

<!-- Role -->
<div class="padding-right" *ngIf="viewRoleDetails">
  <app-role-details></app-role-details>
  <div class=" switch-module-btn" >
    <div class="toggle-view d-flex" (click)="switchModule = true"><i class="pi pi-th-large" pTooltip="Switch Mode" tooltipPosition="bottom"></i></div>
  </div>
</div>
  <p-dialog header="Switch Mode" [(visible)]="switchModule" [modal]="true" [style]="{ width: '800px' }" [maximizable]="true" class="switch-module-dialog">
    <div class="dashboard-grid two-grid">
      <div class="card-container popup-container" *ngFor="let card of cards">
        <div class="card-content">
          <div class="border-class-radius" [ngClass]="card.borderClass" ></div>
          <div class="inner-content align-items-center d-flex switch-module-popup " (click)="viewDetailsClicked(card)">
            <div class="rounded-circle bg-primary-subtle icon-bg">
              <i [ngClass]="card.iconClass"></i>
            </div>
            <div>
            <h3>{{ card.title }}</h3>
            <p>{{ card.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </p-dialog>